
/*
 * 
export default class Singer2 {
  y:'0',
  x:'0',
  visible:false,  
  opacity:0,
  height:'0px',
  hide:function(){
    let vm = this
    this.y ='translateY(-100%)'
    this.opacity = 0          
    setTimeout(function(){
      vm.visible = false
    },500)
    if(this.visible){
      return false
    }else{
      return true
    }
  },
  show:function(){
    let vm = this
    this.visible = true
    setTimeout(function(){
      vm.y = 'translateY(0)'  
      vm.opacity = 1
    },50);
  },
  create(){
    return this
  }
} 
 */
/*
export class Singer2 {
  constructor() {
      this.y ='0'
      this.x ='0'
      this.visible = false  
      this.opacity = 0
      this.height = '0px'
  }
  show(){
    
  }
  hide(){
    
  }
} 
*/
/*
export default class Singer extends  Singer2{
   constructor () { 
     super()
    console.log(9999999999999999999999999999999999)
  }
  show(){ 
    console.log('y',this.y)
  }
  hide(){
    
  }
  
}
*/

export default class Dialog {
  constructor(animationType) {
    this.id = 0  
    this.type = 0 //1:(待定),2:活动窗口
    this.animationType = 2
    if(animationType){
      this.animationType = animationType //1，设置高度显示  2,设置变化Y显示
    }
    this.level = 0  
    this.name = ''
    this.path = ''
    this.y ='translateY(-100%)'
    this.x ='0'
    this.visible = false  
    this.display = false
    this.opacity = 0
    this.height = '0'    
    this.displayTimer = ''
    this.closedSetDocument = true //关闭后是否重新设置页面信息
  }
  setHeight(height){
    clearTimeout(this.displayTimer)
    this.visible = true
    this.display = true
    this.height = height
    let vm = this
    setTimeout(function(){
      vm.y = 'translateY(0)'  
      vm.opacity = 1
    },50);
  }
  isHide(){
    let isHide = false
    switch(this.animationType){
      case 1:
        if( this.height == '0px' || this.height == '0'){
          isHide = true
        }
      break;
      case 2:
        if(this.y == 'translateY(-100%)'){
          isHide = true
        }
      break; 
    }
    return isHide
  }
  show(){   
    this.visible = true
    this.display = true
    if(this.y != 'translateY(0)'){
      let vm = this      
      setTimeout(function(){
        vm.y = 'translateY(0)'  
        vm.opacity = 1
      },50);
    }
  }
  hide(){
    this.visible = false
    let vm = this
    clearTimeout(this.displayTimer)
    this.displayTimer = setTimeout(function() {
      vm.display = false
    },420);
    switch(this.animationType){
      case 1:
        if( this.height != '0px' && this.height != '0' ){
          this.height = '0px'          
        }
      break;
      case 2:
        if(this.y != 'translateY(-100%)'){     
          this.y ='translateY(-100%)'
          this.opacity = 0   
        }
      break; 
    }
  }
} 


//-鲜料============================

//鲜料菜单
export let NewMenuDialog = new Dialog(1)
NewMenuDialog.name = '鲜料'
NewMenuDialog.path = '?view=1'


//-城事精选
export let NewsListDialog = new Dialog(2)
NewsListDialog.animationType = 2
NewsListDialog.name = '城事精选'
NewsListDialog.path = '?view=1&type=1'

//-闲游头条
export let ToutiaoListDialog = new Dialog(2)
ToutiaoListDialog.animationType = 2
ToutiaoListDialog.name = '闲游头条'
ToutiaoListDialog.path = '?view=1&type=2'

//-乡旅动态
export let RenyimenListDialog = new Dialog(2)
RenyimenListDialog.animationType = 2
RenyimenListDialog.name = '乡旅动态'
RenyimenListDialog.path = '?view=1&type=3'
//-鲜料 end========================


//-智图============================

//智图
export let MapsDialog = new Dialog(1)
MapsDialog.name = '智图'
MapsDialog.path = '?view=2'
//地图导航
export let NavigationDialog = new Dialog(2)
NavigationDialog.animationType = 2
NavigationDialog.name = '地图导航'
//VR
export let VrDialog = new Dialog(2)
VrDialog.animationType = 2
VrDialog.name = 'VR'


//-智图 end ========================

//-趣玩============================

//趣玩菜单
export let PlayMenuDialog = new Dialog(1)
PlayMenuDialog.name = '趣玩'
PlayMenuDialog.path = '?view=3'
//达人游记
export let YoujiMenuDialog = new Dialog(2)
YoujiMenuDialog.animationType = 2
YoujiMenuDialog.name = '达人游记'
YoujiMenuDialog.path = '?view=3&type=8'
//全村第一站
export let QuancunMenuDialog = new Dialog(2)
QuancunMenuDialog.animationType = 2
QuancunMenuDialog.name = '全村第一站'
QuancunMenuDialog.path = '?view=3&type=1'
//趣玩攻略
export let GonglvMenuDialog = new Dialog(2)
GonglvMenuDialog.animationType = 2
GonglvMenuDialog.name = '趣玩攻略'
GonglvMenuDialog.path = '?view=3&type=2'
//互动活动
export let CanyuMenuDialog = new Dialog(2)
CanyuMenuDialog.animationType = 2
CanyuMenuDialog.name = '互动活动'
CanyuMenuDialog.path = '?view=3&type=3'
//体验师推荐
export let ExerciseMenuDialog = new Dialog(2)
ExerciseMenuDialog.animationType = 2
ExerciseMenuDialog.name = '体验师推荐'
//专题回顾
export let ActListDialog = new Dialog(2)
ActListDialog.name = '专题回顾'
ActListDialog.path = '?view=3&type=6'

//专题回顾
export let EnjoyActListDialog = new Dialog(2)
EnjoyActListDialog.name = 'VR赏全景'
EnjoyActListDialog.path = '?view=3&type=7'

//2019春节闲游宝典
let Act1Dialog = new Dialog(2)
Act1Dialog.id = 1
Act1Dialog.type = 2
Act1Dialog.animationType = 1
Act1Dialog.name = '2019春节闲游宝典'
Act1Dialog.path = '?act=1'
export {Act1Dialog}
 
let Act1NewsListDialog = new Dialog(2)
Act1NewsListDialog.animationType = 2
Act1NewsListDialog.name = '2019春节闲游宝典-新闻列表'
export {Act1NewsListDialog}


//融水苗族系列坡会群
let Act2Dialog = new Dialog(2)
Act2Dialog.id = 2
Act2Dialog.type = 2
Act2Dialog.animationType = 1
Act2Dialog.name = '融水苗族系列坡会群'
Act2Dialog.path = '?act=2'
export {Act2Dialog}
 
//大歌节
let Act3Dialog = new Dialog(3)
Act3Dialog.id = 3
Act3Dialog.type = 2
Act3Dialog.animationType = 1
Act3Dialog.name = '大歌节'
Act3Dialog.path = '?act=3'
export {Act3Dialog}

//三月三，去撒欢
let Act4Dialog = new Dialog(4)
Act4Dialog.id = 4
Act4Dialog.type = 2
Act4Dialog.animationType = 1
Act4Dialog.name = '三月三，去撒欢'
Act4Dialog.path = '?act=4'
export {Act4Dialog}

//-趣玩 end========================



//-服务 ========================
//服务
export let ServiceDialog = new Dialog(1)
ServiceDialog.name = '服务'
ServiceDialog.path = '?view=4'
//趣玩交通
export let TrafficDialog = new Dialog(1)
TrafficDialog.animationType = 1
TrafficDialog.name = '趣玩交通'
TrafficDialog.path = '?view=4&type=1'
//闲游天气
export let WeatherDialog = new Dialog(1)
WeatherDialog.animationType = 1
WeatherDialog.name = '闲游天气'
WeatherDialog.path = '?view=4&type=2'
//酒店民宿
export let HotelDialog = new Dialog(1)
HotelDialog.animationType = 2
HotelDialog.name = '酒店民宿'
HotelDialog.path = '?view=4&type=3'
//柳味美食
export let FoodDialog = new Dialog(1)
FoodDialog.animationType = 2
FoodDialog.name = '柳味美食'
FoodDialog.path = '?view=4&type=4'
//旅行社
export let GuildDialog = new Dialog(1)
GuildDialog.animationType = 1
GuildDialog.name = '旅行社'
GuildDialog.path = '?view=4&type=5'
//联系我们
export let HelperDialog = new Dialog(1)
HelperDialog.animationType = 1
HelperDialog.name = '联系我们'
GuildDialog.path = '?view=4&type=6'
//乐享柳州
export let LexiangDialog = new Dialog(1)
LexiangDialog.animationType = 1
LexiangDialog.name = '乐享柳州'
GuildDialog.path = '?view=4&type=8'

//-服务 end========================



//-搜索 ========================
export let SearchDialog = new Dialog(1)
SearchDialog.animationType = 1
SearchDialog.name = '搜索'
SearchDialog.closedSetDocument = false
//-搜索 end========================


//文章内容
export let ArticleDialog = new Dialog(2)
ArticleDialog.animationType = 2
ArticleDialog.name = '文章内容'

//评论
export let CommentDialog = new Dialog(2)
CommentDialog.animationType = 2
CommentDialog.name = '评论'
CommentDialog.closedSetDocument = false


// WEBPACK FOOTER //
// ./src/api/MenuDialog.js